import Vue from 'vue';
// Just hiding Vue "unknown element" warnings for external BYU components
Vue.config.ignoredElements = [/^byu-/];
//# sourceMappingURL=byucomponents.js.map